// Extends FontAwesome with custom icons. For examples, see:
// https://github.com/mlwilkerson/fa-custom-icon-demo

export const faAttractions = {
  prefix: 'faz',
  iconName: 'attractions',
  icon: [
    20, // width
    20, // height
    [], // ligatures
    null, // unicode
    'M9.0185.3266a1.639,1.639,0,0,1,1.9636,0L18.4288,5.84a1.2263,1.2263,0,0,1-.6719,2.21H2.2475a1.2252,1.2252,0,0,1-.6744-2.21Zm.9825,4.9011a1.0386,1.0386,0,0,0,.75-.3242,1.1412,1.1412,0,0,0,0-1.5652,1.03,1.03,0,0,0-1.5,0,1.141,1.141,0,0,0,0,1.5652A1.0386,1.0386,0,0,0,10.001,5.2277Zm-6.999,4.15v5.3115H5.547V9.3772ZM1.0935,18.894A2.8188,2.8188,0,0,1,3.85,16.0166H16.1512a2.8191,2.8191,0,0,1,2.7576,2.8774v.4421a.6787.6787,0,0,1-.1865.47.6228.6228,0,0,1-.45.1944H1.73a.623.623,0,0,1-.45-.1944.6786.6786,0,0,1-.1864-.4695ZM16.9992,9.3772v5.3115H14.4541V9.3772Zm-3.8177,0v5.3115h-2.545V9.3772Zm-3.817,0v5.3115H6.82V9.3772Z', // svg path data
  ],
};

export const faArrowNe = {
  prefix: 'faz',
  iconName: 'arrow-ne',
  icon: [
    20,
    20,
    [],
    null,
    'M8.094 3.319v1.5h6.026L3.319 15.62l1.06 1.061L15.181 5.879v6.028h1.5V3.319H8.094z',
  ],
};

export const faCircle = {
  prefix: 'faz',
  iconName: 'circle',
  icon: [
    20,
    20,
    [],
    null,
    'M10 20a10 10 0 1110-10 10.011 10.011 0 01-10 10zm0-17.749A7.749 7.749 0 1017.749 10 7.757 7.757 0 0010 2.251z',
  ],
};

export const faDotCircle = {
  prefix: 'faz',
  iconName: 'dot-circle',
  icon: [
    20,
    20,
    [],
    null,
    'M10 20a10 10 0 1110-10 10.011 10.011 0 01-10 10zm0-17.749A7.749 7.749 0 1017.749 10 7.757 7.757 0 0010 2.251zM10 5a5 5 0 11-5 5 5 5 0 015-5z',
  ],
};

export const faEvents = {
  prefix: 'faz',
  iconName: 'events',
  icon: [
    20,
    20,
    [],
    null,
    'M19.3159.4a.755.755,0,0,0-.7047.478L17.606,3.3119a1.0585,1.0585,0,0,1-.2158.3806L16.0693,5.0239a1.1857,1.1857,0,0,1-.5714.32l-2.1028.4948a2.127,2.127,0,0,0-1.1366.659L10.47,8.4812A2.1653,2.1653,0,0,0,9.9418,9.58l-.4076,2.4618a.7216.7216,0,0,0,.3268.7292.71.71,0,0,0,.7934-.0254.7205.7205,0,0,0,.2893-.4677l.3923-2.3764,1.521-1.3808v2.876a1.46,1.46,0,0,1-.0486.3715l-1.8319,6.926a.7249.7249,0,0,0,.0621.5268.7121.7121,0,0,0,1.2912-.0743l2.6172-6.5933,1.7456,2.7382.4567,3.678a.723.723,0,0,0,.274.4815.7114.7114,0,0,0,.5322.1425.7473.7473,0,0,0,.6119-.8l-.2039-3.4947a2.6874,2.6874,0,0,0-.2128-1.0526L16.8,11.33a1.4564,1.4564,0,0,1-.1337-.6092V7.645a.9633.9633,0,0,1,.1647-.54L18.66,4.3937l.0014-.0038a2.0847,2.0847,0,0,0,.2019-.3758l1.082-2.6173a.7254.7254,0,0,0-.0566-.6634A.7128.7128,0,0,0,19.3164.4ZM13.8094.88a1.897,1.897,0,0,0-1.3469.5623,1.9306,1.9306,0,0,0,0,2.7151,1.8942,1.8942,0,0,0,2.6937,0,1.9309,1.9309,0,0,0,0-2.7151A1.8971,1.8971,0,0,0,13.8094.88ZM.7143,1.84a.7118.7118,0,0,0-.5051.2109A.723.723,0,0,0,0,2.56V5.4641A1.6868,1.6868,0,0,0,.611,6.7657L2.8571,8.56l-.8143,2.682a3.5743,3.5743,0,0,0-.1076,1.4616l.6886,6.2544a.7217.7217,0,0,0,.2328.457.7107.7107,0,0,0,.4757.1842c.0134,0,.0272,0,.04-.0009a.712.712,0,0,0,.4793-.2241.7227.7227,0,0,0,.195-.4949V13.0476l.3443-.2084,2.0533,2.2583.2233,3.8239a.7322.7322,0,0,0,.7347.6777.7118.7118,0,0,0,.4914-.2183.7232.7232,0,0,0,.2016-.5016V14.8311a1.7212,1.7212,0,0,0-.27-.9157l-1.7785-2.566.9442-2.31a1.4392,1.4392,0,0,1,.2353-.3874L9.1228,6.4168a1.6825,1.6825,0,0,0,.4008-1.0919V2.56a.7229.7229,0,0,0-.2091-.5091.71.71,0,0,0-1.01,0,.7229.7229,0,0,0-.2091.5091V5.1449L8.09,5.1478l-1.5619,1.43A.2369.2369,0,0,1,6.37,6.64H3.7881a.7136.7136,0,0,1-.361-.0984L1.4286,5.3657V2.56a.723.723,0,0,0-.2092-.5091A.7118.7118,0,0,0,.7143,1.84Zm4.0475,0a1.8973,1.8973,0,0,0-1.3468.5623,1.9306,1.9306,0,0,0,0,2.7151,1.8939,1.8939,0,0,0,2.6937,0,1.9306,1.9306,0,0,0,0-2.7151A1.8974,1.8974,0,0,0,4.7618,1.84Z',
  ],
};

export const faFilter = {
  prefix: 'faz',
  iconName: 'filter',
  icon: [
    20,
    20,
    [],
    null,
    'M9.62 5.13a3.94 3.94 0 1 0 .24 1.59H18V5.13zM5.94 8.84A2.35 2.35 0 1 1 8.29 6.5a2.34 2.34 0 0 1-2.35 2.34zm7.88.72a4 4 0 0 0-3.94 3.94v.05H2v1.59h8.25a3.94 3.94 0 1 0 3.57-5.58zm0 6.29a2.35 2.35 0 1 1 2.35-2.35 2.35 2.35 0 0 1-2.35 2.35z',
  ],
};

export const faImageUpload = {
  prefix: 'faz',
  iconName: 'image-upload',
  icon: [
    20,
    20,
    [],
    null,
    'M16.19 11.43a1 1 0 0 0-.68.28.93.93 0 0 0-.28.67v.36l-1.41-1.41a2.66 2.66 0 0 0-3.74 0l-.66.67-2.36-2.36a2.72 2.72 0 0 0-3.75 0L1.9 11.05V5.71a1 1 0 0 1 1-1h6.62a.93.93 0 0 0 .67-.28 1 1 0 0 0 0-1.35.93.93 0 0 0-.67-.28H2.86A2.87 2.87 0 0 0 0 5.71v11.43A2.87 2.87 0 0 0 2.86 20h11.42a2.87 2.87 0 0 0 2.86-2.86v-4.76a.93.93 0 0 0-.28-.67 1 1 0 0 0-.67-.28ZM2.86 18.09a1 1 0 0 1-.68-.27 1 1 0 0 1-.28-.68v-3.4L4.67 11a.74.74 0 0 1 1 0l3 3 4.1 4.09Zm12.37-.95a.87.87 0 0 1-.17.51l-4.29-4.32.66-.67a1 1 0 0 1 .24-.16.72.72 0 0 1 .29-.06.67.67 0 0 1 .28.06 1 1 0 0 1 .24.16l2.75 2.78Zm4.49-14L16.86.27a1 1 0 0 0-1.35 0l-2.86 2.86a1 1 0 0 0 0 1.35 1 1 0 0 0 1.36 0l1.22-1.24v5.33a1 1 0 0 0 1.91 0V3.24l1.23 1.24a.85.85 0 0 0 .31.21.89.89 0 0 0 .36.07.94.94 0 0 0 .37-.07 1.06 1.06 0 0 0 .31-.21 1 1 0 0 0 .21-.31.89.89 0 0 0 .07-.36.93.93 0 0 0-.28-.68Z',
  ],
};

export const faOffice365 = {
  prefix: 'faz',
  iconName: 'office365',
  icon: [
    20,
    20,
    [],
    null,
    'M1.7 16.133V3.975L12.455 0 18.3 1.87v16.367L12.455 20 1.7 16.133l10.756 1.295V3.274L5.44 4.91v9.586z',
  ],
};

export const faOpenStreetMap = {
  prefix: 'faz',
  iconName: 'openstreetmap',
  icon: [
    20,
    20,
    [],
    null,
    'M2.672 23.969c-.352-.089-.534-.234-1.471-1.168C.085 21.688.014 21.579.018 20.999c0-.645-.196-.414 3.368-3.986 3.6-3.608 3.415-3.451 4.064-3.449.302 0 .378.016.62.14l.277.14 1.744-1.744-.218-.343c-.425-.662-.825-1.629-1.006-2.429a7.657 7.657 0 011.479-6.44c2.49-3.12 6.959-3.812 10.26-1.588 1.812 1.218 2.99 3.099 3.328 5.314.07.467.07 1.579 0 2.074a7.554 7.554 0 01-2.205 4.402 6.712 6.712 0 01-1.943 1.401c-.959.483-1.775.71-2.881.803-1.573.131-3.32-.305-4.656-1.163l-.343-.218-1.744 1.744.14.28c.125.241.14.316.14.617.003.651.156.467-3.426 4.049-2.761 2.756-3.186 3.164-3.398 3.261-.271.125-.69.171-.945.106zM17.485 13.95a6.425 6.425 0 004.603-3.51c1.391-2.899.455-6.306-2.227-8.108-.638-.43-1.529-.794-2.367-.962-.581-.117-1.809-.104-2.414.025a6.593 6.593 0 00-2.452 1.064c-.444.315-1.177 1.048-1.487 1.487a6.384 6.384 0 00.38 7.907 6.406 6.406 0 003.901 2.136c.509.078 1.542.058 2.065-.037zm-3.738 7.376a80.97 80.97 0 01-2.196-.651c-.025-.028 1.207-4.396 1.257-4.449.023-.026 4.242 1.152 4.414 1.236.062.026-.003.288-.525 2.102a398.513 398.513 0 00-.635 2.236c-.025.087-.069.156-.097.156-.028-.003-1.028-.287-2.219-.631zm2.912.524c0-.053 1.227-4.333 1.246-4.347.047-.034 4.324-1.23 4.341-1.211.019.019-1.199 4.337-1.23 4.36-.02.019-4.126 1.191-4.259 1.218-.054.011-.098 0-.098-.019zm-7.105-1.911c.846-.852 1.599-1.627 1.674-1.728.171-.218.405-.732.472-1.015.026-.118.053-.352.058-.522l.011-.307.182-.051c.103-.028.193-.044.202-.034.023.025-1.207 4.321-1.246 4.36-.02.016-.677.213-1.464.436l-1.425.405 1.537-1.542zm8.289-3.06a1.371 1.371 0 01-.059-.187l-.044-.156.156-.028c1.339-.227 2.776-.856 3.908-1.713.16-.125.252-.171.265-.134.054.165.272.95.265.959-.034.034-4.48 1.282-4.492 1.261zm-15.083-1.3c-.05-.039-1.179-3.866-1.264-4.29-.016-.084.146-.044 2.174.536 2.121.604 2.192.629 2.222.74.028.098.011.129-.125.223-.084.059-.769.724-1.523 1.479a63.877 63.877 0 01-1.39 1.367c-.016 0-.056-.025-.093-.054zm.821-4.378c-1.188-.343-2.164-.623-2.167-.626-.016-.012 1.261-4.433 1.285-4.46.022-.022 4.422 1.211 4.469 1.252.009.009-.269 1.017-.618 2.239-.576 2.02-.643 2.224-.723 2.22-.05-.003-1.059-.285-2.247-.626zm2.959.538c.012-.031.212-.723.444-1.534l.42-1.476.056.321c.093.556.265 1.188.464 1.741.106.296.187.539.181.545-.008.006-.332.101-.719.212-.389.109-.741.21-.786.224-.058.016-.075.006-.059-.034zM4.905 6.112c-1.187-.339-2.167-.635-2.18-.654-.04-.062-1.246-4.321-1.23-4.338.026-.025 4.31 1.204 4.351 1.246.047.051 1.28 4.379 1.246 4.376L4.91 6.113zm2.148-1.713l-.519-1.806-.078-.28 1.693-.483c.934-.265 1.724-.495 1.76-.508.034-.016-.083.14-.26.336A8.729 8.729 0 007.69 5.23a4.348 4.348 0 00-.132.561c0 .293-.115-.025-.505-1.39z',
  ],
};

export const faOutlook = {
  prefix: 'faz',
  iconName: 'outlook',
  icon: [
    20,
    20,
    [],
    null,
    'M12.595 14.93V9.623c.377.26.73.5 1.082.742.316.217.37.215.695-.002l5.42-3.601c.055-.037.112-.07.192-.12.006.083.015.145.015.206v6.927a1.022 1.022 0 01-1.152 1.155h-6.252zm.014-10.693h6.566a.816.816 0 01.79.596c.054.16 0 .238-.13.324q-2.464 1.65-4.922 3.308c-.234.159-.47.31-.7.475a.291.291 0 01-.368.01c-.375-.242-.756-.473-1.129-.717a.296.296 0 01-.127-.203c-.006-1.24-.004-2.48-.002-3.72a.331.331 0 01.022-.073zM11.654 20c-3.889-.815-7.762-1.625-11.648-2.437v-.256Q.006 9.909 0 2.512c0-.205.055-.275.254-.312q4.66-.891 9.322-1.797C10.26.268 10.946.137 11.654 0v20zm-3.1-10.02a4.352 4.352 0 00-.522-2.243A2.346 2.346 0 006.64 6.592a2.462 2.462 0 00-2.976 1.465 4.861 4.861 0 00-.377 2.502 3.585 3.585 0 00.762 2.031 2.36 2.36 0 003.675.016 4.013 4.013 0 00.83-2.625zm-4.005.018a2.846 2.846 0 01.404-1.637 1.126 1.126 0 011.267-.52 1.179 1.179 0 01.79.727 3.446 3.446 0 01.235 1.873 3.84 3.84 0 01-.289 1.04 1.082 1.082 0 01-1.02.673 1.137 1.137 0 01-1.046-.636 2.908 2.908 0 01-.342-1.52z',
  ],
};

export const faPrice = {
  prefix: 'faz',
  iconName: 'price',
  icon: [
    20,
    20,
    [],
    null,
    'M20 12.51a.73.73 0 0 0-.73-.73 1.3 1.3 0 0 1-1-.52 2.09 2.09 0 0 1-.41-1.26 2.07 2.07 0 0 1 .41-1.26 1.3 1.3 0 0 1 1-.52.73.73 0 0 0 .73-.73V5.26a3 3 0 0 0-3-2.95h-2.7a.66.66 0 0 0-.36.11.7.7 0 0 1-.74 0 .72.72 0 0 0-.37-.11H3a3 3 0 0 0-3 2.95v2.23a.73.73 0 0 0 .73.73 1.3 1.3 0 0 1 1 .52A2.09 2.09 0 0 1 2.14 10a2.07 2.07 0 0 1-.41 1.26 1.3 1.3 0 0 1-1 .52.73.73 0 0 0-.73.73v2.23a3 3 0 0 0 3 3h9.86a.7.7 0 0 0 .37-.11.7.7 0 0 1 .74 0 .7.7 0 0 0 .37.11H17a3 3 0 0 0 3-3ZM12.83 3.9a.74.74 0 0 1 1.47 0v1.33a.74.74 0 1 1-1.47 0Zm0 3.65a.74.74 0 1 1 1.47 0v1.29a.74.74 0 0 1-1.47 0Zm0 3.6a.74.74 0 0 1 1.47 0v1.3a.74.74 0 0 1-1.47 0Zm.73 5.68a.74.74 0 0 1-.73-.74v-1.33a.74.74 0 0 1 1.47 0v1.33a.74.74 0 0 1-.74.74Z',
  ],
};

export const faSaved = {
  prefix: 'faz',
  iconName: 'saved',
  icon: [
    20,
    20,
    [],
    null,
    'M17.527 0H2.473A1.487 1.487 0 001 1.498V18.5a1.482 1.482 0 00.872 1.367 1.435 1.435 0 001.583-.253l6.217-5.661a.485.485 0 01.655 0l6.217 5.661a1.439 1.439 0 001.583.253A1.481 1.481 0 0019 18.5V1.498A1.487 1.487 0 0017.527 0zM15.36 6.944l-2.776 1.78a.302.302 0 00-.12.36l1.074 2.92a.302.302 0 01-.447.358l-2.928-1.877a.303.303 0 00-.326 0l-2.929 1.877a.302.302 0 01-.447-.359l1.076-2.92a.302.302 0 00-.12-.359L4.64 6.944a.302.302 0 01.163-.557H8.32a.302.302 0 00.283-.198l1.114-3.024a.302.302 0 01.568 0l1.114 3.024a.302.302 0 00.284.198h3.515a.302.302 0 01.163.557z',
  ],
};

export const faShare = {
  prefix: 'faz',
  iconName: 'share',
  icon: [
    20,
    20,
    [],
    null,
    'M14.35 5.371a.897.897 0 01-1.27 0l-1.934-1.934v8.73a.898.898 0 01-1.796 0v-8.73L7.415 5.37a.898.898 0 01-1.27-1.27L9.613.635l.001-.001.634-.634.634.634.002.002 3.467 3.466a.897.897 0 010 1.27zm3.73 1.161h-3.142a.898.898 0 100 1.796h1.347v9.876H3.715V8.328h1.347a.898.898 0 100-1.796H1.919V20h16.162z',
  ],
};

export const faSort = {
  prefix: 'faz',
  iconName: 'sort',
  icon: [
    20,
    20,
    [],
    null,
    'M10,18.41l-4.71-4.7,1.42-1.42L10,15.59l3.29-3.3,1.42,1.42ZM14.71,6.29,10,1.59,5.29,6.29,6.71,7.71,10,4.41l3.29,3.3Z',
  ],
};

export const faWidgets = {
  prefix: 'faz',
  iconName: 'widgets',
  icon: [
    20,
    20,
    [],
    null,
    'M7.7274,10.9086H1.3637A1.3637,1.3637,0,0,0,0,12.2723v6.3636A1.3637,1.3637,0,0,0,1.3637,20H7.7274A1.3636,1.3636,0,0,0,9.091,18.6359V12.2723A1.3636,1.3636,0,0,0,7.7274,10.9086Zm-.6816,7.0457h-5V12.9538h5Zm11.59-7.0452H12.2726a1.3636,1.3636,0,0,0-1.3636,1.3636v6.3637A1.3637,1.3637,0,0,0,12.2726,20h6.3637A1.3637,1.3637,0,0,0,20,18.6364V12.2727A1.3636,1.3636,0,0,0,18.6363,10.9091Zm-.6816,7.0456h-5v-5h5ZM18.6363,0H12.2726A1.3636,1.3636,0,0,0,10.909,1.3636V7.7273a1.3636,1.3636,0,0,0,1.3636,1.3636h6.3637A1.3636,1.3636,0,0,0,20,7.7273V1.3636A1.3636,1.3636,0,0,0,18.6363,0Zm-.6816,7.0456h-5v-5h5ZM7.7275,0H1.3639A1.3637,1.3637,0,0,0,0,1.3636V7.7273A1.3637,1.3637,0,0,0,1.3639,9.0909H7.7275A1.3636,1.3636,0,0,0,9.0912,7.7273V1.3636A1.3636,1.3636,0,0,0,7.7275,0ZM7.046,7.0456H2.0455v-5H7.046Z',
  ],
};
